/** Card bios and detail-page copy (from standalone HTML). Keyed by member name. */
export const teamsMetaByName = {
  'Rajesh Sharma': {
    slug: 'rajesh-sharma',
    bio: 'Founder of the Capri Group with three decades of experience building lending, asset-management and stressed-asset franchises in India.',
    detailParagraphs: [
      "A first-generation entrepreneur, Rajesh Sharma is one of the Designated Partners of Capri Global Investment Managers LLP. He is also the founder and Managing Director of Capri Global Capital Limited (CGCL), one of India's leading Non-Banking Financial Companies (NBFCs). Under his guidance, the NBFC currently has a strong foothold in the country, with over 3,80,000 customers, 935 branches across 32 states and a total loan book value of more than INR 15,000 crores.",
      "Leveraging his experience of more than 25 years in the Indian Financial industry, Rajesh has played an instrumental role in raising more than INR 4,50,000 crores worth of debt for various Indian corporates across sectors. A qualified Chartered Accountant, Rajesh Sharma's vision for Capri Global Investment Managers LLP is to tap into the approximately INR 1 trillion mid-market stressed assets space for risk-adjusted yet outsized returns on investments.",
    ],
  },
  'Sanjay Jain': {
    slug: 'sanjay-jain',
    bio: 'Over three decades across stressed assets, capital markets, investment banking and corporate & project lease finance.',
    detailParagraphs: [
      'Sanjay Jain joins Capri Global Investment Managers LLP as Managing Director and Chief Investment Officer with over three decades of experience across stressed assets, capital markets, investment banking and corporate & project lease finance.',
      "He brings deep expertise in originating, underwriting and executing complex special-situations investments across India's mid-market. Sanjay leads the firm's investment strategy and is responsible for driving value creation across the portfolio.",
    ],
  },
  'P. R. Srinivasan': {
    slug: 'pr-srinivasan',
    bio: 'Veteran private-equity investor and founder of Global Investment Capital Partners, leading our investment committee.',
    detailParagraphs: [
      'P. R. Srinivasan is a veteran private-equity investor and the founder of Global Investment Capital Partners. He leads the investment committee at Capri Global Investment Managers LLP and brings decades of experience in private equity, corporate strategy and business turnaround.',
      "His track record spans control and significant minority investments across India's mid-market, with a particular focus on enabling resilient businesses to scale through patient, equity-oriented capital.",
    ],
  },
  'Devinjit Singh': {
    slug: 'devinjit-singh',
    bio: 'Co-founder of Global Investment Capital Partners with over 30 years of mid-market private equity experience.',
  },
  'Saurabh Johri': {
    slug: 'saurabh-johri',
    bio: 'Extensive background in financial management and investment across AIFs and development finance.',
  },
  'Umesh Biyani': {
    slug: 'umesh-biyani',
    bio: 'Rank-holder Chartered Accountant with over 24 years in stressed asset investment and management.',
  },
  'Archit Varma': {
    slug: 'archit-varma',
    bio: 'Seven years in financial services with deep experience in stressed assets and special situations.',
  },
  'Anshul Dhanuka': {
    slug: 'anshul-dhanuka',
    bio: 'Chartered Accountant and Company Secretary with over 13 years in finance and strategy.',
  },
  'Sujit Baral': {
    slug: 'sujit-baral',
    bio: 'CFA Charterholder with 13+ years across special situations, structured credit, and real estate investments.',
    detailParagraphs: [
      '13+ years across SP Investment Advisors Pvt Ltd, Asset Reconstruction Company (India) Limited, Axis Bank, and Infosys, spanning buy-side investing, distressed credit, and corporate lending.',
      'Strong track record in special situations and structured credit, with ~$500M deployed and $10Bn+ evaluated across sectors, including hands-on experience in valuation, restructuring, and deal execution.',
      'Most recently VP at SP Investment Advisors, leading >$1Bn of real estate investment evaluation and managing ~3 mn sq. ft. Grade A assets across the full lifecycle (origination to exit).',
      'CFA Charterholder with deep expertise in financial modelling, credit underwriting, and legal frameworks (IBC, SARFAESI), now bringing this experience to the current role at Capri Global Investment Managers LLP.',
    ],
  },
};

export function enrichTeamMember(member) {
  const meta = teamsMetaByName[member.name] ?? {};
  const slug = meta.slug ?? member.name.toLowerCase().replace(/\s+/g, '-');
  return {
    ...member,
    slug,
    bio: meta.bio,
    detailParagraphs: meta.detailParagraphs ?? (member.description ? [member.description] : []),
  };
}
